export default __webpack_public_path__ + "static/media/peopleAmount.68d6154f.svg";